var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewConvGroupMobileIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "New_broadcast_mobile",
    "data-name": "New broadcast mobile",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1364",
    "data-name": "Rectangle 1364",
    width: 24,
    height: 24,
    fill: "none",
    stroke: "#1450ff",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4169",
    "data-name": "Group 4169",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1223",
    "data-name": "Path 1223",
    d: "M1.864,3.709A6.055,6.055,0,0,0,.838,7.292a6.274,6.274,0,0,0,1.418,3.851",
    transform: "translate(0.018 0.079)",
    fill: "none",
    stroke: "#1450ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1224",
    "data-name": "Path 1224",
    d: "M3.879,1.79A5.494,5.494,0,0,1,6.9.938a5.646,5.646,0,0,1,3.887,1.251,6.876,6.876,0,0,1,2.346,3.686",
    transform: "translate(0.083 0.02)",
    fill: "none",
    stroke: "#1450ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1225",
    "data-name": "Path 1225",
    d: "M1.866,3.772S.458.724.806.75C1.083.77,4,1.807,3.987,1.809",
    transform: "translate(0.016 0.016)",
    fill: "none",
    stroke: "#1450ff",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1226",
    "data-name": "Path 1226",
    d: "M1.906,19.994A6.055,6.055,0,0,1,.88,16.411a6.269,6.269,0,0,1,6.391-6.147,6.281,6.281,0,1,1-.265,12.56,5.5,5.5,0,0,1-3.021-.852",
    transform: "translate(0.019 0.218)",
    fill: "none",
    stroke: "#1450ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1227",
    "data-name": "Path 1227",
    d: "M1.908,19.791S.5,22.838.848,22.813c.277-.02,3.2-1.057,3.181-1.059",
    transform: "translate(0.017 0.421)",
    fill: "none",
    stroke: "#1450ff",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1228",
    "data-name": "Path 1228",
    d: "M4.492,15.843a.746.746,0,0,1,.73.766.767.767,0,1,1-.73-.766",
    transform: "translate(0.079 0.337)",
    fill: "#1450ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1229",
    "data-name": "Path 1229",
    d: "M7.289,15.843a.746.746,0,0,1,.73.766.767.767,0,1,1-.73-.766",
    transform: "translate(0.138 0.337)",
    fill: "#1450ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1230",
    "data-name": "Path 1230",
    d: "M10.009,15.843a.746.746,0,0,1,.73.766.767.767,0,1,1-.73-.766",
    transform: "translate(0.196 0.337)",
    fill: "#1450ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1231",
    "data-name": "Path 1231",
    d: "M10.367,11.119,10.6,9.837a6.324,6.324,0,0,1,5.851-5,6.6,6.6,0,0,1,3.223.758,5.709,5.709,0,0,1,2.2,1.924,6.864,6.864,0,0,1,1.1,3.882,5.553,5.553,0,0,1-.924,3.009",
    transform: "translate(0.221 0.103)",
    fill: "none",
    stroke: "#1450ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1232",
    "data-name": "Path 1232",
    d: "M19.96,16.207a6.01,6.01,0,0,1-3.595.941,6.231,6.231,0,0,1-2.757-.785",
    transform: "translate(0.29 0.345)",
    fill: "none",
    stroke: "#1450ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1233",
    "data-name": "Path 1233",
    d: "M19.828,16.25s3,1.489,2.984,1.139c-.013-.279-.973-3.233-.975-3.217",
    transform: "translate(0.422 0.302)",
    fill: "none",
    stroke: "#1450ff",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1234",
    "data-name": "Path 1234",
    d: "M17.977,10.446H15.542a.766.766,0,1,1,0-1.532h2.435a.766.766,0,0,1,0,1.532",
    transform: "translate(0.314 0.19)",
    fill: "#1450ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1235",
    "data-name": "Path 1235",
    d: "M17.977,13.2H15.542a.766.766,0,1,1,0-1.532h2.435a.766.766,0,0,1,0,1.532",
    transform: "translate(0.314 0.248)",
    fill: "#1450ff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewConvGroupMobileIcon);
export default __webpack_public_path__ + "static/media/new-conv-group-mobile-icon.7daf14c2730e92a6a660d13f08cdc5d1.svg";
export { ForwardRef as ReactComponent };